import React, {useContext} from "react";
import { Link } from "react-router-dom";
import CountryContext from "../CountryContext";
import {useHomeLinks} from "@feature/home/hooks/useHomeLinks";
import Placeholder from "@ui-components/Placeholder";
import {useIntl} from "react-intl";


const HomeLink = ({title, description, to, external}: {
  title: string;
  description?: string | React.ReactNode;
  to: string;
  external: boolean;
}) => {

  const content = (
    <div className="flex flex-col">
      <p className="font-semibold text-2xl">
        {title}
      </p>
      {!!description && <p>{description}</p>}
    </div>
  );
  const Wrapper = external
    ? (props: Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "rel" | "target" | "href">) => (
      <a rel="noreferrer" target="_blank" href={to} {...props} />
    )
    : (props: Omit<React.ComponentProps<typeof Link>, "to">) => <Link to={to} {...props} />;

  return (
    <Wrapper className={
      "w-full border-2 border-black-500 px-4 pt-3 pb-4 cursor-pointer hover:bg-am-500 hover:text-white text-am-500 bg-white"
    }>
      {content}
    </Wrapper>
  )
}


const Home = () => {

  // context
  const {
    country: { code },
  } = useContext(CountryContext);

  // hooks
  const intl = useIntl();
  const { loading, data } = useHomeLinks();

  // utilities
  const getLocaleValue = (key: string, defaultValue?: string, ...args: any[]) => {
    const found = key in intl.messages;
    return !found && defaultValue !== undefined ? defaultValue : intl.formatMessage({id: key}, ...args);
  }

  return (
    <div className="flex flex-col min-h-full pt-10 gap-12">
      <h1 className="text-black-500 text-5xl">
        Genius Lab Building Platform
      </h1>
      <div className="border-t-2 border-black-500" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
        {loading && Array.from({ length: 4 }).map((_, i) => (
          <Placeholder key={i} width="w-full" height="h-24" marginClass="" />
        ))}
        {!loading && data?.map((link) => {
          const isExternal = !link.internal_section_key;
          return (
            <HomeLink
              key={link.id}
              title={getLocaleValue(link.locale_key)}
              description={getLocaleValue(link.locale_key + "_description", "") || <>&nbsp;</>}
              to={isExternal ? link.external_link_url! : `/${code}/${link.internal_section_key}`}
              external={isExternal}
            />
          )
        })}
      </div>
    </div>
  );
};

export default Home;
